import type { TUserFacility } from './facility';

export enum EUserFacilityRelationType {
  ADMINISTRATE = 'default',
  READ = 'readonly',
}

export type TUserFacilityRelation = {
  id: number
  facility_id: TUserFacility
};
